/**
 * @flow
 * @relayHash 5bfeac74eb99df19dd4a5dc4bdcfa9d5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CategoryTemplateCreateInput = {|
  name: string,
  code: string,
|};
export type CreateCategoryTemplateMutationVariables = {|
  data: CategoryTemplateCreateInput
|};
export type CreateCategoryTemplateMutationResponse = {|
  +createCategoryTemplate: {|
    +id: string
  |}
|};
export type CreateCategoryTemplateMutation = {|
  variables: CreateCategoryTemplateMutationVariables,
  response: CreateCategoryTemplateMutationResponse,
|};
*/


/*
mutation CreateCategoryTemplateMutation(
  $data: CategoryTemplateCreateInput!
) {
  createCategoryTemplate(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CategoryTemplateCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createCategoryTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CategoryTemplateModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateCategoryTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateCategoryTemplateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateCategoryTemplateMutation",
    "id": null,
    "text": "mutation CreateCategoryTemplateMutation(\n  $data: CategoryTemplateCreateInput!\n) {\n  createCategoryTemplate(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4757c7faec79e9ad12f54b900513ad31';
module.exports = node;
